import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import { i18n } from '@/plugins/i18n'
import axios from 'axios'
import { createApp } from 'vue'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import { store } from './store/store'
import Multiselect from 'vue-multiselect'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faAngleLeft as fasAngleLeft, faCircleInfo, faFileExport, faPlus, faTrash, faTrianglePersonDigging } from '@fortawesome/pro-solid-svg-icons'

library.add(fasAngleLeft, faCircleInfo, faFileExport, faPlus, faTrash, faTrianglePersonDigging);

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon);

app.component('vue-multiselect', Multiselect);

app.use(i18n);

//https://www.npmjs.com/package/vue-axios
app.use(VueAxios, axios);


//https://router.vuejs.org/guide/
app.use(router);

app.use(store);

app.mount('#app')